var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"margin-top":"60px","margin-bottom":"60px"},attrs:{"fluid":""}},[_c('v-row',{},[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12"}},[_c('center',[_c('v-img',{attrs:{"src":"img/vazhl_4.png","fluid":""}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }